import React, { useState, useRef, useEffect } from 'react';
import i18n from '../i18n';
import './LanguageSwitcher.css';

export default function LanguageSwitcher({ style }) {
    const [isOpen, setIsOpen] = useState(false);
    const current = i18n.language || 'en';
    const dropdownRef = useRef(null);

    const handleChange = (lang) => {
        try { localStorage.setItem('lng', lang); } catch { }
        i18n.changeLanguage(lang);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, []);

    const languages = {
        en: { flag: '🇺🇸', name: 'English' },
        es: { flag: '🇲🇽', name: 'Español' },
        'fr-CA': { flag: '🇨🇦', name: 'Français (Canada)' }
    };
    const resolvedCurrent = languages[current] ? current : 'en';

    return (
        <div className="language-switcher-mobile" style={style} ref={dropdownRef}>
            <button 
                className="lang-trigger" 
                onClick={() => setIsOpen(!isOpen)}
                aria-label="Change language"
                aria-expanded={isOpen}
            >
                <span className="current-flag">{languages[resolvedCurrent].flag}</span>
                <span className="current-name">{languages[resolvedCurrent].name}</span>
                <svg 
                    className={`dropdown-arrow ${isOpen ? 'open' : ''}`} 
                    width="12" 
                    height="8" 
                    viewBox="0 0 12 8"
                >
                    <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
            </button>
            
            {isOpen && (
                <div className="lang-dropdown">
                    {Object.entries(languages).map(([code, { flag, name }]) => (
                        <button
                            key={code}
                            className={`lang-option ${current === code ? 'active' : ''}`}
                            onClick={() => handleChange(code)}
                        >
                            <span className="flag">{flag}</span>
                            <span className="name">{name}</span>
                            {current === code && <span className="check">✓</span>}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
